import App from "@/App.vue";
import { createApp } from "vue";
import { createWebHistory, createRouter } from "vue-router";
import VueVideoPlayer from '@videojs-player/vue'

// styles

// import 'vuetify/dist/vuetify.min.css' 
import "vue-search-select/dist/VueSearchSelect.css";
import '@vuepic/vue-datepicker/dist/main.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
// import "@/assets/styles/tailwind.css";
import '@/assets/styles/main.css';
import '@/assets/styles/css/index.css';
import 'video.js/dist/video-js.css'

import Auth from "@/layouts/Auth.vue";
import Admin from "@/layouts/Admin.vue";
import ClientNav from "@/layouts/ClientNav.vue";
import { Cookie } from '@/utils/request';

import ClientLayout from '@/layouts/Client.vue';
import ClientIndex from '@/views/client/Index.vue';
import ClientLogin from '@/views/client/Login.vue';
import ClientCourseSatus from "@/views/client/CourseSatus.vue";
import ClientRegister from '@/views/client/Register.vue';
import ClientBase from '@/layouts/ClientBase.vue';
import ClientLibrary from '@/views/client/Library.vue';

import Login from "@/views/auth/Login.vue";

import CourseGroupTable from "@/views/admin/CoursePreparation/CourseGroupTable.vue";
import CourseGroupAdd from "@/views/admin/CoursePreparation/CourseGroupAdd.vue";
import CourseGroupSettings from "@/views/admin/CoursePreparation/CourseGroupSettings.vue";

import CoursePreparationTable from "@/views/admin/CoursePreparation/CoursePreparationList.vue";
import TrainingsIndex from "@/views/admin/Trainings/Index.vue";
import TrainingsAdd from "@/views/admin/Trainings/TrainingsAdd.vue";
import TrainingsSettings from "@/views/admin/Trainings/TrainingsSettings.vue";
import TrainingClientIndex from "@/views/client/trainings/Index.vue";

import CoursePreparationAdd from "@/views/admin/CoursePreparation/CoursePreparationAdd.vue";
import CoursePreparationSettings from "@/views/admin/CoursePreparation/CoursePreparationSettings.vue";
import CoursePreparationStatus from "@/views/admin/CoursePreparation/CoursePreparationStatus.vue";
import CoursePreparationEstimates from "@/views/admin/CoursePreparation/CoursePreparationEstimates.vue";
import ClientCourses from "@/views/client/ClientCourses.vue";
import ResponsesList from "@/views/client/ResponsesList.vue";
const ModeratorResponsesList = () => import('./views/client/ModeratorResponsesList.vue')
import ClienntTsor from "@/views/client/ClientTsor.vue";
import ClienntTsorTitles from "@/views/client/Tsor/TsorTitles.vue";
import ClienntTsorTheme from "@/views/client/Tsor/TsorTheme.vue";
import ClientLabWork from "@/views/client/LabWork/LabWorkDetail.vue";
import Certificate from "@/views/client/Certificate.vue";

import ContentPage from "@/views/admin/content/ContentPage.vue";
import ContentEdit from "@/views/admin/content/ContentEdit.vue";
import ScienceTable from "@/views/admin/Science/ScienceTable.vue";
import ScienceSettings from "@/views/admin/Science/ScienceSettings.vue";
import ScienceAdd from "@/views/admin/Science/ScienceAdd.vue";

import CategoryView from '@/views/admin/category/Index.vue';
import CategoryEdit from '@/views/admin/category/Edit.vue';

import PilotAnnouncementsIndex from '@/views/admin/PilotAnnouncements/Index.vue';
import PilotAnnouncementEdit from '@/views/admin/PilotAnnouncements/Edit.vue';

import PilotServicesIndex from '@/views/admin/PilotServices/Index.vue';

import Page from '@/views/pages/Page.vue';
import PageDetail from '@/views/pages/PageDetail.vue';
import PageDetailExperts from '@/views/pages/PageDetailExperts.vue';
import ExpertSearch from '@/views/pages/ExpertSearch.vue';
import PilotAnnouncementDetail from '@/views/pages/PilotAnnouncementDetail.vue';
import ExpertsIndex from '@/views/admin/Experts/Index.vue';
import ExpertEdit from '@/views/admin/Experts/Edit.vue';
import OnlineEducation from '@/views/pages/OnlineEducation.vue';
import CourseDetail from '@/views/pages/CourseDetail.vue';
import UsersIndex from '@/views/admin/Users/Index.vue';
import UsersEdit from '@/views/admin/Users/Edit.vue';
import PasswordRecoveryIndex from '@/views/admin/PasswordRecovery/Index.vue';
import FreedomPayOrders from '@/views/admin/FreedomPayOrders/FreedomPayOrders.vue';
import LoginAttemptsIndex from '@/views/admin/LoginAttempts/Index.vue';
import UserFeedbackIndex from '@/views/admin/UserFeedback/Index.vue';
import ClientFeedback from '@/views/client/Feedback.vue';
import ClientProfile from '@/views/client/Profile.vue';
import ExperProfieletList from '@/views/client/ExperProfieletList.vue';
import PaymentProcedure from '@/views/pages/PaymentProcedure.vue';
import Offer from '@/views/pages/Offer.vue';
import PrivacyPolicy from '@/views/pages/PrivacyPolicy.vue';


// import { Cookie } from '@/utils/request';

// function getUser() {
//   const userCookie = Cookie.get('user');
//   if (!userCookie) return {};
//   return JSON.parse(userCookie);
// }

// function getRedirectPath() {
//   const user = getUser();
//   if (!user.role) return '/admin/user';
//   return NAV[user.role.key][0].link;
// }

const routes = [
  {
    path: "/auth",
    redirect: "/auth/login",
    component: Auth,
    children: [
      {
        path: "/auth/login",
        component: Login,
        name: 'Login',
      },
    ],
  },
  {
    path: "/client/certificate",
    redirect: "/auth/login",
    component: Certificate,
    children: [
      {
        path: "/client/certificate/:userId/:uuid",
        component: Certificate,
      },
      {
        path: "/client/certificate/:uuid",
        component: Certificate,
      },
    ],
  },
  {
    path: "/admin",
    // redirect: getRedirectPath(),
    component: Admin,
    children: [
      {
        path: "/admin/course-group",
        component: CourseGroupTable,
        name: 'CourseGroupTable'
      },
      {
        path: "/admin/experts",
        component: ExpertsIndex,
        name: 'ExpertsList'
      },
      {
        path: "/admin/experts/edit/:id",
        component: ExpertEdit,
        name: 'ExpertEdit'
      },
      {
        path: "/admin/experts/create",
        component: ExpertEdit,
        name: 'ExpertCreate'
      },
      {
        path: "/admin/users",
        component: UsersIndex,
        name: 'UsersList'
      },
      {
        path: "/admin/users/create",
        component: UsersEdit,
        name: 'UsersCreate'
      },
      {
        path: "/admin/users/edit/:id",
        component: UsersEdit,
        name: 'UsersEdit'
      },
      {
        path: "/admin/password-recovery",
        component: PasswordRecoveryIndex,
        name: 'PasswordRecoveryIndex'
      },
      {
        path: "/admin/login-attempts",
        component: LoginAttemptsIndex,
        name: 'LoginAttemptsList'
      },
      {
        path: "/admin/course-group-add",
        component: CourseGroupAdd,
        name: 'CourseGroupAdd'
      },
      {
        path: "/admin/course-group/:id",
        component: CourseGroupSettings,
        name: 'CourseGroupSettings'
      },
      {
        path: "/admin/science",
        component: ScienceTable,
        name: 'ScienceTable'
      },
      {
        path: "/admin/science-add",
        component: ScienceAdd,
        name: 'ScienceAdd'
      },
      {
        path: "/admin/science/:id",
        component: ScienceSettings,
        name: 'ScienceSettings'
      },
      {
        path: "/admin/trainings",
        component: TrainingsIndex,
        name: 'TrainingsIndex'
      },
      {
        path: "/admin/trainings-add",
        component: TrainingsAdd,
        name: 'TrainingsAdd'
      },
      {
        path: "/admin/trainings/:id",
        component: TrainingsSettings,
        name: 'TrainingsSettings'
      },
      {
        path: "/admin/course-preparation",
        component: CoursePreparationTable,
        name: 'CoursePreparationTable'
      },
      {
        path: "/admin/course-preparation-add",
        component: CoursePreparationAdd,
        name: 'CoursePreparationAdd'
      },
      {
        path: "/admin/course-preparation/:id",
        component: CoursePreparationSettings,
        name: 'CoursePreparationSettings'
      },
      {
        path: "/admin/course/status",
        component: CoursePreparationStatus,
        name: 'CoursePreparationStatus'
      },
      {
        path: "/admin/course/estimates",
        component: CoursePreparationEstimates,
        name: 'CoursePreparationEstimates'
      },      
      {
        path: "/admin/content/:type",
        component: ContentPage,
        name: 'ContentPage'
      },
      {
        path: "/admin/content/create",
        component: ContentEdit,
        name: 'ContentEdit'
      },
      {
        path: "/admin/content/edit/:slug",
        component: ContentEdit,
        name: 'ContentEditDetail'
      },
      {
        path: "/admin/category",
        component: CategoryView,
        name: 'CategoryList'
      },
      {
        path: "/admin/category/:contentType",
        component: CategoryView,
        name: 'CategoryDetailList'
      },
      {
        path: "/admin/categories/edit/:contentType/:id",
        component: CategoryEdit,
        name: 'CategoryEdit'
      },
      {
        path: "/admin/category/create",
        component: CategoryEdit,
        name: 'CategoryCreate'
      },
      {
        path: "/admin/pilot-announcements",
        component: PilotAnnouncementsIndex,
        name: 'PilotAnnouncementsList'
      },
      {
        path: "/admin/pilot-announcements/create",
        component: PilotAnnouncementEdit,
        name: 'PilotAnnouncementCreate'
      },
      {
        path: "/admin/pilot-announcements/edit/:id",
        component: PilotAnnouncementEdit,
        name: 'PilotAnnouncementEdit'
      },
      {
        path: "/admin/pilot-services",
        component: PilotServicesIndex,
        name: 'PilotServicesList'
      },
      {
        path: "/admin/payment-orders",
        component: FreedomPayOrders,
        name: 'FreedomPayOrders'
      },
      {
        path: "/admin/user-feedback",
        component: UserFeedbackIndex,
        name: 'UserFeedbackIndex'
      },

    ]
  },
  {
    path: "",
    redirect: "",
    component: ClientLayout,
    children: [
      {
        path: "",
        component: ClientIndex,
        name: 'ClientIndex'
      },
      {
        path: "/client/login",
        component: ClientLogin,
        name: 'ClientLogin'
      },
      {
        path: "/client/register",
        component: ClientRegister,
        name: 'ClientRegister'
      },
      {
        path: "/client/feedback",
        component: ClientFeedback,
        name: 'ClientFeedback'
      },
      {
        path: "/client",
        redirect: "/client",
        component: ClientNav,
        children: [
          {
            path: "/client/course-status",
            component: ClientCourseSatus,
            name: 'ClientCourseSatus'
          },
          {
            path: "/client/profile",
            component: ClientProfile,
            name: 'ClientProfile'
          },
          {
            path: "/client/experts",
            component: ExperProfieletList,
            name: 'ExperProfieletList'
          },
          {
            path: "/client/courses/",
            component: ClientCourses,
            name: 'ClientCourses'
          },
          {
            path: "/client/responses",
            component: ResponsesList,
            name: 'ResponsesList'
          },
          {
            path: "/client/moderator-responses",
            component: ModeratorResponsesList,
            name: 'ModeratorResponsesList'
          },
        ],
      },
      {
        path: "/client/tsor",
        redirect: "/client/tsor",
        component: ClientNav,
        children: [
          {
            path: "/client/tsor",
            component: ClienntTsor,
            name: 'ClienntTsor'
          },
          {
            path: "/client/tsor/:uuid",
            component: ClienntTsorTitles,
            name: 'ClienntTsorTitles'
          },
          {
            path: "/client/tsor/:uuid/:themeUUID",
            component: ClienntTsorTheme,
            name: 'ClienntTsorTheme'
          },
        ],
      },
      {
        path: "/client/lab-work",
        redirect: "/client/lab-work",
        component: ClientNav,
        children: [
          {
            path: "/client/lab-work/:labWorkUUID",
            component: ClientLabWork,
            name: 'ClientLabWork'
          },
        ],
      },
      {
        path: "/client/trainings",
        redirect: "/client/trainings",
        component: ClientNav,
        children: [
          {
            path: "/client/trainings",
            component: TrainingClientIndex,
            name: 'TrainingClientIndex'
          },
        ],
      },
      {
        path: "/privacy-policy",
        component: PrivacyPolicy,
        name: 'PrivacyPolicy'
      },
      {
        path: "/payment-procedure",
        component: PaymentProcedure,
        name: 'PaymentProcedure'
      },
      {
        path: "/offer",
        component: Offer,
        name: 'Offer'
      },
      {
        path: "/news",
        component: ClientBase,
        name: 'ClientBase',
        children: [
          {
            path: "/news-1",
            component: ClientLibrary,
            name: 'ClientLibrary'
          },
          {
            path: "/experts",
            component: ExpertSearch,
            name: 'ExpertSearch',
          },
          {
            path: "/experts/:id",
            component: PilotAnnouncementDetail,
            name: 'PilotAnnouncementDetail',
          },
          {
            path: "/page/experts/:slug",
            component: PageDetailExperts,
            name: 'PageContentDetailExperts',
          },
          {
            path: "/page/:contentType/:slug",
            component: PageDetail,
            name: 'PageContentDetail',
          },
          {
            path: "/page/:contentType",
            component: Page,
            name: 'PageContent',
          },
          {
            path: "/education",
            component: OnlineEducation,
            name: 'ClientEducation'
          },
          {
            path: "/courses/:courseId",
            component: CourseDetail,
            name: 'CourseDetail'
          },
        ]
      },
    ],
  },
  { path: "/:pathMatch(.*)*", redirect: "", },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.path.startsWith('/admin')) {
    const userCookie = Cookie.get('user');
    let userRole = -1;
    if (userCookie) {
      try {
        const userStore = JSON.parse(userCookie);
        userRole = userStore.role?.key;
      } catch (e) {
        console.error('Error parsing user cookie:', e);
      }
    }
    if (userRole === 0 || userRole === 3) {
      next();
    } else {
      next('/');
    }
  } else {
    next();
  }
});

import user from '@/store/user.js';
import '@/utils/axiosConfig.js'; // Setup global axios interceptors
// import NAV from "./const/roleNav";

// Load reCAPTCHA v2 script
const script = document.createElement('script');
script.src = 'https://www.google.com/recaptcha/api.js';
script.async = true;
script.defer = true;
document.head.appendChild(script);

createApp(App)
  .use(user)
  .use(VueVideoPlayer)
  .provide('$router', router)
  .use(router)
  .mount("#app");
